import { SessionResponse } from "./types";

type ParseSessionResponseReturnType = {
  maskedMobileNumber: string;
  otpVerifyUrl: string;
  otpResendUrl: string;
} | null;

export function parseSessionResponse(
  data: SessionResponse,
): ParseSessionResponseReturnType {
  const maskedMobileNumber = data.mobile_phone;

  if (!maskedMobileNumber) {
    console.error(
      "Masked mobile number is missing is the create session response.",
    );
    return null;
  }

  const otpVerifyUrl = data.links.find(({ rel }) => rel === "verify")?.href;

  if (!otpVerifyUrl) {
    console.error("Verify OTP URL is missing is the create session response.");
    return null;
  }

  const otpResendUrl = data.links.find(({ rel }) => rel === "resend")?.href;

  if (!otpResendUrl) {
    console.error("Resend OTP URL is missing is the create session response.");
    return null;
  }

  return {
    maskedMobileNumber,
    otpVerifyUrl,
    otpResendUrl,
  };
}
